import React from 'react';
import { Fade } from 'react-awesome-reveal';
import Sidebar from '../Sidebar';
import { SettingTabs as Tabs } from '../Sidebar/Tabs';
import { useRouter } from 'next/router';
import Link from 'next/link';
import OperationStatus from '../Common/OperationStatus';
import { HugeiconsIcon } from '@hugeicons/react';
import { ArrowLeft01Icon } from '@hugeicons/core-free-icons';
type PagesProps = {
  children: JSX.Element;
};

const PagesLayout = ({ children }: PagesProps) => {
  const router = useRouter();
  const { tabId } = router.query;

  const currentPageIndex = Tabs.findIndex((tab) => tab.id === tabId);

  return (
    <div className="flex h-[100%] overflow-y-auto w-full">
      <Sidebar tabId={tabId as string} surveyId={12} Tabs={Tabs} />
      <Fade className="w-full">
        <div
          className="flex w-full flex-1 flex-col h-screen"
          role="main"
          aria-label="Page main content"
        >
          <header className="min-h-12 h-12 flex items-center justify-between border-b border-border-color px-4 space-x-2">
            <div className="flex flex-row space-x-2 items-center">
              <Link href="/home">
                <HugeiconsIcon
                  icon={ArrowLeft01Icon}
                  size={28}
                  color="#4a4a4a"
                  strokeWidth={1.5}
                  className="cursor-pointer hover:bg-background-color rounded-md p-1"
                />
              </Link>
              <span className="heading-4 capitalize">
                {router.pathname === '/settings'
                  ? 'User Management'
                  : Tabs[currentPageIndex]?.text ?? ''}
              </span>
            </div>
            <div className="self-center">
              <OperationStatus />
            </div>
          </header>
          {children}
        </div>
      </Fade>
    </div>
  );
};

export default PagesLayout;
